import React, { useState } from "react";
import { supabase } from "../supabaseClient";
import { useNavigate } from "react-router-dom";

const SetPassword = () => {
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (
      password.length < 8 ||
      !/[A-Z]/.test(password) ||
      !/\d/.test(password)
    ) {
      setError(
        "Password must be at least 8 characters, include a capital letter and a number."
      );
      return;
    }

    const {
      data: { session },
      error: sessionError,
    } = await supabase.auth.getSession();

    if (!session || sessionError) {
      setError("Session not found. Please login again.");
      return;
    }

    const { error: updateError } = await supabase.auth.updateUser({
      password,
    });

    if (updateError) {
      setError(updateError.message);
    } else {
      const {
        data: { session: newSession },
      } = await supabase.auth.getSession();
      const userId = newSession?.user?.id;

      if (userId) {
        const { data: profile } = await supabase
          .from("creator_profiles")
          .select("id")
          .eq("user_id", userId)
          .single();

        if (profile) {
          navigate("/dashboard");
        } else {
          navigate("/profile");
        }
      } else {
        navigate("/login");
      }
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#020617] via-[#050816] to-black text-slate-100 flex flex-col">
      {/* Top mini-nav */}
      <header className="w-full max-w-5xl mx-auto flex items-center justify-between px-4 pt-4 pb-2">
        <div className="flex items-center gap-2">
          <img
            src="/Dreamframelogo.png"
            alt="Dreamframe Logo"
            className="h-8 w-8 rounded-md object-cover shadow-[0_0_16px_rgba(124,58,237,0.6)]"
          />
          <span className="text-sm font-semibold tracking-wide text-cyan-200">
            Dreamframe Studio
          </span>
        </div>
        <button
          type="button"
          onClick={() => navigate("/")}
          className="rounded-2xl border border-slate-500/70 bg-slate-900/80 px-3 py-1.5 text-xs font-medium text-slate-100 hover:bg-slate-800 hover:border-cyan-300/70"
        >
          ← Back to main site
        </button>
      </header>

      {/* Centered form */}
      <div className="flex-1 flex flex-col items-center justify-center px-4 pb-10">
        <form
          onSubmit={handleSubmit}
          className="w-full max-w-md rounded-3xl border border-white/10 bg-slate-900/95 px-6 py-7 shadow-[0_18px_45px_rgba(0,0,0,0.85)] backdrop-blur flex flex-col gap-4"
        >
          <div className="text-center mb-1">
            <img
              src="/Dreamframelogo.png"
              alt="Dreamframe Logo"
              className="mx-auto h-16 w-16 rounded-xl object-cover shadow-[0_0_30px_rgba(129,140,248,0.7)] mb-3"
            />
            <h2 className="text-lg font-semibold text-sky-200 mb-1">
              🔐 Set Your Password
            </h2>
            <p className="text-[11px] text-slate-400">
              Secure your account with a strong password. You’ll use this for
              direct email + password logins.
            </p>
          </div>

          <div className="flex flex-col gap-1">
            <label className="text-xs font-semibold text-slate-200">
              New password
            </label>
            <input
              type="password"
              placeholder="New password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full rounded-xl border border-slate-600 bg-slate-950/70 px-3 py-2 text-sm text-slate-100 placeholder:text-slate-500 focus:border-cyan-400 focus:outline-none"
            />
          </div>

          <div className="flex flex-col gap-1">
            <label className="text-xs font-semibold text-slate-200">
              Confirm password
            </label>
            <input
              type="password"
              placeholder="Confirm password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              className="w-full rounded-xl border border-slate-600 bg-slate-950/70 px-3 py-2 text-sm text-slate-100 placeholder:text-slate-500 focus:border-cyan-400 focus:outline-none"
            />
          </div>

          {error && (
            <p className="mt-1 text-center text-[12px] text-rose-400">{error}</p>
          )}

          <button
            type="submit"
            className="mt-2 w-full rounded-2xl bg-gradient-to-r from-indigo-500 via-fuchsia-500 to-pink-500 px-4 py-2.5 text-sm font-semibold text-white shadow-md shadow-fuchsia-500/40 hover:brightness-110"
          >
            Set Password
          </button>
        </form>

        <footer className="mt-4 text-center text-[11px] text-slate-400">
          © {new Date().getFullYear()} Dreamframe Studio. All rights reserved.
        </footer>
      </div>
    </div>
  );
};

export default SetPassword;
